/**
 * 新闻相关接口
 */
import { get, postForm, encodePath } from './request'

/**
 * 分页获取新闻标题列表
 * @param {number} page 当前页（从 1 开始）
 * @param {number} size 每页条数
 */
export function getNewsList(page, size) {
  return get(`/admin/news/getTitle/${encodePath(page)}/${encodePath(size)}`)
}

/**
 * 根据 id 获取新闻详情
 * @param {number|string} id 新闻 id
 */
export function getNewsDetail(id) {
  return postForm('/admin/news/selectById', { id })
}

/**
 * 根据 id 获取上/下一篇新闻
 * @param {number|string} id 新闻 id
 */
export function getNewsSibling(id) {
  return postForm('/admin/news/getTwoId', { id })
}



// WEBPACK FOOTER //
// ./src/api/news.js